import React from "react";
import { Box } from "@mui/material";

/** Ana logo — public/genius-crm-logo.svg */
export default function BrandLogo({ size, align = "left", onClick, sx = {} }) {
  const objectPosition = align === "center" ? "center center" : "left center";
  const clickable = typeof onClick === "function";

  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/genius-crm-logo.svg`}
      alt="Genius CRM"
      decoding="async"
      role={clickable ? "link" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      sx={{
        display: "block",
        height: "auto",
        width: "100%",
        objectFit: "contain",
        objectPosition,
        flexShrink: 0,
        imageRendering: "auto",
        boxShadow: "none",
        ...(size != null && size !== ""
          ? { maxHeight: typeof size === "number" ? `${size}px` : size }
          : {}),
        ...(clickable
          ? {
              cursor: "pointer",
              transition: "opacity 0.15s ease, filter 0.15s ease",
              "&:hover": { opacity: 0.88 },
            }
          : {}),
        ...sx,
      }}
    />
  );
}
